export default "__VITE_ASSET__CYUTShYR__"